import React, { useContext, ReactNode } from 'react';
import classNames from 'classnames';
import close from '@uswds/uswds/dist/img/usa-icons/close.svg';
import HeaderContext from './context/HeaderContext';
import HeaderVariantType from './types/HeaderVariantType';

export interface HeaderNavProps {
  children: ReactNode;
}

const HeaderNav = ({ children }: HeaderNavProps): JSX.Element => {
  const { setShowMenu, showMenu, headerVariant } = useContext(HeaderContext);

  return (
    <nav aria-label="Primary Navigation" className={classNames('usa-nav', { 'is-visible': showMenu })}>
      {headerVariant === HeaderVariantType.Extended ? (
        <div className="usa-nav__inner">
          <button type="button" className="usa-nav__close" onClick={(): void => setShowMenu(false)}>
            <img src={close} alt="close" />
          </button>
          {children}
        </div>
      ) : null}
      {headerVariant !== HeaderVariantType.Extended ? (
        <>
          <button type="button" className="usa-nav__close" onClick={(): void => setShowMenu(false)}>
            <img src={close} alt="close" />
          </button>
          {children}
        </>
      ) : null}
    </nav>
  );
};

export default HeaderNav;
